import { ArbeitsbereichStation } from '@/domain/mitarbeiter/features/rotationsplan/entities/Station';
import { Interval } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/entities/Interval';
import { KalenderMitarbeiter } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/entities/kalenderByMitarbeiter/KalenderMitarbeiter';

export class KalenderByArbeitsbereicheStation extends Interval {
  constructor({
    station,
    mitarbeiter,
  }: {
    station: ArbeitsbereichStation;
    mitarbeiter: KalenderMitarbeiter[];
  }) {
    super({ von: station.von, bis: station.bis });
    this.mitarbeiter = mitarbeiter;
    this.station = station;
  }

  mitarbeiter: KalenderMitarbeiter[];
  station: ArbeitsbereichStation;
}
